import React, {useEffect, useState} from 'react';
import {GetCookieInfo} from "../../logic/CookieManager";
import {Box, Grid, Modal, Snackbar, TextField, Typography} from "@mui/material";
import {StyledAlert, StyledButtonBlack, StyledButtonOrange} from "../../styles/MyStyles";
import {TreeItem, TreeView} from "@mui/x-tree-view";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import {GetEnumValueName, GetFileTypeMenuItems} from "../../logic/EnumHelper";
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import DeleteIcon from '@mui/icons-material/Delete';
import VisibilityIcon from '@mui/icons-material/Visibility';
import {DownloadFileFromBlob} from "../../logic/FileDownloader";
import {Document, Page, pdfjs} from 'react-pdf';
import {GetClient} from "../../logic/DataProvider";

const ManagerFilesPage = React.forwardRef((props, ref) => {
    const clientId = props.clientId;
    const [client, setClient] = useState();
    const [filesToUpload, setFilesToUpload] = useState();
    const [filesStructure, setFilesStructure] = useState(null);
    const [typeOfFileToUpload, setTypeOfFileToUpload] = useState(0);
    const [showModal, setShowModal] = useState(false);
    const [expanded, setExpanded] = useState([]);
    const [previewFile, setPreviewFile] = useState(null);
    const [previewModalDimensions, setPreviewModalSize] = useState({ width: 0, height: 0 });
    const [previewPdfModalIsOpen, setPreviewPdfModalIsOpen] = useState(false);
    const [previewImageModalIsOpen, setPreviewImageModalIsOpen] = useState(false);
    const [numPagesInPreview, setNumPagesInPreview] = useState(null);
    const [snackbar, setSnackbar] = React.useState({
        open: false,
        vertical: 'top',
        horizontal: 'center',
        message: ''
    });

    React.useImperativeHandle(ref, () => ({
        handleUploadFileClick,
        handleDownloadBucketClick
    }));

    pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

    const setFilesAsStructure = (files) => {
        let newStructure = [];
        files.forEach((file) => {
            let structItem = newStructure.find((e) => e.name === GetEnumValueName('fileType', file.type));
            if (structItem) {
                structItem.children.push({
                    'name': file.name,
                    'fileType': file.type,
                    'structType': 'file'
                });
            } else {
                newStructure.push({
                    'name': GetEnumValueName('fileType', file.type),
                    'structType': 'folder',
                    'children': [{
                        'name': file.name,
                        'fileType': file.type,
                        'structType': 'file'
                    }]
                });
            }
        });
        setFilesStructure(newStructure);
        console.log(newStructure);
    };
    const fetchFiles = async () => {
        try {
            const tokenCookie = GetCookieInfo('nplt');
            const response = await fetch(
                `${process.env.REACT_APP_FILES_URL}/${clientId}`,
                {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: 'Bearer ' + tokenCookie.value,
                    },
                }
            );
            if (response.ok) {
                const data = await response.json();
                setFilesAsStructure(data.data);
                console.log(data.data);

            } else {
                console.log('Fetch files failed.');
            }
        } catch (error) {
            console.log('An error occurred:', error);
        }
    };
    useEffect(() => {
        GetClient(clientId).then((value) => setClient(value));
        fetchFiles();
    }, [clientId]);
    const uploadFile = async (e) => {
        console.log(filesToUpload);

        try {
            const tokenCookie = GetCookieInfo('nplt');

            const formData = new FormData();

            for (const file of filesToUpload) {
                formData.append('files', file);
            }

            formData.append("contactId", clientId);
            formData.append("type", typeOfFileToUpload);

            const response = await fetch(
                `${process.env.REACT_APP_FILES_URL}/upload`,
                {
                    method: 'POST',
                    headers: {
                        Authorization: 'Bearer ' + tokenCookie.value,
                    },
                    body: formData,
                }
            );
            if (response.ok) {
                console.log('File uploaded successfully.');
                fetchFiles();
                handleClose();
            } else {
                console.log('File uploading failed.');
            }
        } catch (error) {
            console.log('An error occurred:', error);
        }
    };
    const saveFile = (e) => {
        setFilesToUpload(e.target.files);
    };
    const handleNodeToggle = (event, nodeIds) => {
        setExpanded(nodeIds);
    };
    const HierarchicalTreeView = ({ data }) => {
        return (
            <TreeView
                expanded={expanded}
                onNodeToggle={handleNodeToggle}
                defaultCollapseIcon={<ExpandMoreIcon />}
                defaultExpandIcon={<ChevronRightIcon />}>
                {data.map((item) => {
                    if (item.structType === 'folder') {
                        return <FolderComponent key={item.name + Math.random().toString()} folder={item} />;
                    } else if (item.structType === 'file') {
                        return <FileComponent key={item.name + Math.random().toString()} file={item} />;
                    }
                    return null;
                })}
            </TreeView>
        );
    };
    const FolderComponent = ({ folder }) => {
        return (
            <TreeItem nodeId={folder.name} label={
                <div style={{ display: 'flex', alignItems: 'center', height: '40px' }}>
                    <Typography variant="body1">{folder.name}</Typography>
                </div>
            }>
                {folder.children && folder.children.map((child) => (
                    <FileComponent key={child.name} file={child} />
                ))}
            </TreeItem>
        );
    };
    const FileComponent = ({ file }) => {
        return (
            <TreeItem nodeId={file.name} label={
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', height: '40px' }}>
                    <Typography variant="body2">{file.name}</Typography>
                    <div>
                        <StyledButtonOrange
                            disabled={!file.name.endsWith('.pdf') && !file.name.endsWith('.jpg') && !file.name.endsWith('.jpeg') && !file.name.endsWith('.png')}
                            variant="contained" color="primary" size="small" onClick={() => loadPreviewFile(file)}>
                            <VisibilityIcon />
                        </StyledButtonOrange>
                        <StyledButtonOrange variant="contained" color="primary" size="small" onClick={() => downloadFile(file)}>
                            <CloudDownloadIcon />
                        </StyledButtonOrange>
                        <StyledButtonBlack variant="contained" color="secondary" size="small" onClick={() => removeFile(file)}>
                            <DeleteIcon />
                        </StyledButtonBlack>
                    </div>
                </div>
            } />
        );
    };
    const downloadFile = async (file)  => {
        try {
            const tokenCookie = GetCookieInfo('nplt');
            const response = await fetch(
                `${process.env.REACT_APP_FILES_URL}/download`,
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: 'Bearer ' + tokenCookie.value,
                    },
                    body: JSON.stringify({
                        'contactId': clientId,
                        'fileName': file.name,
                        'type': file.fileType
                    })
                }
            );
            if (response.ok) {
                await DownloadFileFromBlob(response, file.name);
            } else {
                console.log('Download file failed.');
            }
        } catch (error) {
            console.log('An error occurred:', error);
        }
    }
    const downloadBucket = async ()  => {
        try {
            const tokenCookie = GetCookieInfo('nplt');
            const response = await fetch(
                `${process.env.REACT_APP_FILES_URL}/download-bucket/${clientId}`,
                {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: 'Bearer ' + tokenCookie.value,
                    }
                }
            );
            if (response.ok) {
                await DownloadFileFromBlob(response, 'archive.zip');
            } else {
                console.log('Download bucket failed.');
            }
        } catch (error) {
            console.log('An error occurred:', error);
        }
    }
    const loadPreviewFile = async (file)  => {
        try {
            const tokenCookie = GetCookieInfo('nplt');
            const response = await fetch(
                `${process.env.REACT_APP_FILES_URL}/download`,
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: 'Bearer ' + tokenCookie.value,
                    },
                    body: JSON.stringify({
                        'contactId': clientId,
                        'fileName': file.name,
                        'type': file.fileType
                    })
                }
            );
            if (response.ok) {
                const blob = await response.blob();
                setPreviewFile(blob);

                if (file.name.endsWith('.pdf')) {
                    await calculatePreviewModalSize(blob);
                    openPreviewPdfModal();
                } else {
                    openPreviewImageModal();
                }
            } else {
                console.log('Download file failed.');
            }
        } catch (error) {
            console.log('An error occurred:', error);
        }
    }
    const removeFile = async (file)  => {
        try {
            const tokenCookie = GetCookieInfo('nplt');
            const response = await fetch(
                `${process.env.REACT_APP_FILES_URL}/remove`,
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: 'Bearer ' + tokenCookie.value,
                    },
                    body: JSON.stringify({
                        'contactId': clientId,
                        'fileName': file.name,
                        'type': file.fileType
                    })
                }
            );
            if (response.ok) {
                fetchFiles();
            } else {
                console.log('Remove file failed.');
            }
        } catch (error) {
            console.log('An error occurred:', error);
        }
    }
    const handleOpen = () => {
        setShowModal(true);
    };
    const handleClose = () => {
        setTypeOfFileToUpload(0);
        setFilesToUpload(null);
        setShowModal(false);
    };
    const handleUploadFileClick = () => {
        handleOpen();
    };
    const handleDownloadBucketClick = () => {
        if (filesStructure.length !== 0) {
            downloadBucket();
        } else {
            setSnackbar({ ...snackbar, open: true, message: 'There are no files yet.'})
        }
    };
    const handleCloseSnackbar = () => {
        setSnackbar({ ...snackbar, open: false });
    };
    const openPreviewPdfModal = () => {
        setPreviewPdfModalIsOpen(true);
    };
    const openPreviewImageModal = () => {
        setPreviewImageModalIsOpen(true);
    };
    const closePreviewPdfModal = () => {
        setPreviewPdfModalIsOpen(false);
        setPreviewFile(null);
    };
    const closePreviewImageModal = () => {
        setPreviewImageModalIsOpen(false);
        setPreviewFile(null);
    };
    const onDocumentLoadSuccess = ({ numPages }) => {
        setNumPagesInPreview(numPages);
    };
    const renderPreviewPages = () => {
        const pages = [];
        for (let pageIndex = 0; pageIndex < numPagesInPreview; pageIndex++) {
            pages.push(
                <Page scale={1.5} key={pageIndex} pageNumber={pageIndex + 1}
                      renderTextLayer={false}
                      renderAnnotationLayer={false}/>
            );
        }
        return pages;
    };
    const calculatePreviewModalSize = async (pdfFile) => {
        const pdfDocument = await pdfjs.getDocument({ url: URL.createObjectURL(pdfFile) }).promise;
        const page = await pdfDocument.getPage(1);
        const viewport = page.getViewport({ scale: 1.5 });

        let x = window.innerWidth - 90;
        let y = window.innerHeight - 90;

        let width = x > viewport.width ? viewport.width : x;
        let height = y > viewport.height ? viewport.height : y;

        setPreviewModalSize({ width: width, height: height });
    };

    return (
        <>
            <Snackbar
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                open={snackbar.open}
                autoHideDuration={6000}
                onClose={handleCloseSnackbar}>
                <StyledAlert onClose={handleCloseSnackbar} severity="error" sx={{ width: '100%' }}>
                    {snackbar.message}
                </StyledAlert>
            </Snackbar>
            {previewFile && (<Modal open={previewPdfModalIsOpen} onClose={closePreviewPdfModal}>
                <Box sx={{
                    position: 'absolute',
                    margin: 'auto',
                    width: `${previewModalDimensions.width}px`,
                    height: `${previewModalDimensions.height}px`,
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    bgcolor: 'background.paper',
                    border: '2px solid #000',
                    boxShadow: 24,
                    p: 4,
                    overflowY: 'auto'
                }}>
                    <Document file={previewFile} onLoadSuccess={onDocumentLoadSuccess}>
                        <>
                            {numPagesInPreview && renderPreviewPages()}
                        </>
                    </Document>
                </Box>
            </Modal>)}
            {previewFile && (<Modal open={previewImageModalIsOpen} onClose={closePreviewImageModal}>
                <Box sx={{
                    position: 'absolute',
                    margin: 'auto',
                    width: `auto`,
                    height: `auto`,
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    bgcolor: 'background.paper',
                    border: '2px solid #000',
                    boxShadow: 24,
                    p: 4,
                    overflowY: 'auto'
                }}>
                    <img src={URL.createObjectURL(previewFile)} alt="Preview" style={{ maxWidth: '100%' }} />
                </Box>
            </Modal>)}
            {filesStructure && filesStructure.length !== 0 && (<HierarchicalTreeView data={filesStructure} />)}
            {filesStructure && filesStructure.length === 0 && (<Typography variant="h6" component="h2">
                    There are no files yet.
                </Typography>)}
            {showModal && (<Modal open={showModal} onClose={handleClose}>
                <Box sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: 400,
                        bgcolor: 'background.paper',
                        border: '2px solid #000',
                        boxShadow: 24,
                        p: 4,
                    }}>
                    <Typography variant="h6" component="h2">
                        Upload file
                    </Typography>
                    <TextField
                        select
                        label="Type"
                        value={typeOfFileToUpload}
                        onChange={(event) => setTypeOfFileToUpload(event.target.value)}
                        margin="normal"
                        size="small"
                        fullWidth
                    >
                        {GetFileTypeMenuItems(client.type)}
                    </TextField>
                        <input id='filePicker' multiple={true} type="file" onChange={saveFile} style={{ display: 'none' }}/>
                        <label htmlFor='filePicker'>
                            <Grid container alignItems="center">
                            <StyledButtonOrange variant="contained" component="span">
                                Choose a file
                            </StyledButtonOrange>
                            <Typography variant="body1" style={{ marginLeft: '8px' }}>
                                {filesToUpload
                                    ? filesToUpload.length > 1 ? `Picked ${filesToUpload.length} files` :  filesToUpload[0].name
                                    : 'No file selected'}
                            </Typography>
                            </Grid>
                        </label>

                    <Grid container spacing={2} marginTop={3}>
                        <Grid item xs={12} md={6}>
                            <StyledButtonBlack onClick={handleClose}>
                                Close
                            </StyledButtonBlack>
                        </Grid>
                        <Grid item xs={12} md={6} sx={{ textAlign: 'right' }}>
                            <StyledButtonOrange onClick={uploadFile}>
                                Upload
                            </StyledButtonOrange>
                        </Grid>
                    </Grid>
                </Box>
            </Modal>)}
        </>
    );
});

export default ManagerFilesPage;
